import React from "react";

const Introduction = ({ title, tag }) => {
  return (
    <div className="section">
      <div className="heading introduction" id={tag}>
        <h3>{title}</h3>
      </div>
      <div className="content">
        <div className="row">
          <div className="col">
            <p>
              Welcome — I'm C.W. Hambleton (Chris Hambleton), and I believe
              fact and fiction both unlock deeper truths about the world
              around us.
              <br />
              <br />
              Here you'll find heart-racing thrillers, introspective biblical
              fiction, and insightful nonfiction — all inviting you to think
              beyond the ordinary. For more personal reflections, I blog at{" "}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://beingrefactored.com"
              >
                BeingRefactored.com
              </a>
              .
            </p>
            <div style={{ textAlign: "center", margin: 30 }}>
              <em>
                Exploring the boundaries of faith, truth, and imagination
                through speculative fiction, political intrigue, and
                thought-provoking nonfiction!
              </em>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Introduction;
